import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import copy from 'copy-to-clipboard';

import { Tabs, SharingMethods } from '@spotahome/ui-library';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

import sharingLinkGenerators from '../common/sharing-links';

import { getReferrerLink } from '../common/utils';

import './FormSuccess.scss';

import ReferralCopy from './ReferralCopy';

const FormSuccess = ({ link, code, userName }) => {
  const { whatsapp, email, facebook, twitter } = SharingMethods.types;

  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);

  useEffect(() => {
    if (copiedCode || copiedLink) {
      const copiedTimeout = setTimeout(() => {
        setCopiedCode(false);
        setCopiedLink(false);
      }, 3000);
      return () => copiedTimeout && clearTimeout(copiedTimeout);
    }
    return () => {};
  }, [copiedCode, copiedLink]);

  const onShareMethodClick = method => {
    const generateSharingLink = sharingLinkGenerators[method];

    if (generateSharingLink) {
      window.open(
        generateSharingLink({
          code,
          userName,
          queryParams: {
            utm_source: 'spotahome',
            utm_medium: 'sharebuttonexternal',
            utm_campaign: method
          }
        })
      );
    }
  };

  const handleCopyCode = () => {
    copy(code);
    setCopiedCode(true);
  };

  const handleCopyLink = () => {
    copy(
      getReferrerLink({
        code,
        params: {
          utm_medium: 'copy',
          utm_campaign: 'referral_external'
        }
      })
    );

    setCopiedLink(true);
  };

  const sections = [
    {
      label: trans('external.refer_a_friend.form.success.link'),
      render: () => (
        <ReferralCopy
          label={trans('external.refer_a_friend.form.success.link')}
          referralData={link}
          onCopy={handleCopyLink}
          isCopied={copiedLink}
          ctaCopyLabel={trans('external.refer_a_friend.form.success.copy-code')}
          ctaCopiedLabel={trans('referrals.dashboard.copied')}
          dataTest={'ext-referral-formSuccess-link'}
        />
      )
    },
    {
      label: trans('external.refer_a_friend.form.success.code'),
      render: () => (
        <ReferralCopy
          label={trans('external.refer_a_friend.form.success.code')}
          referralData={code}
          onCopy={handleCopyCode}
          isCopied={copiedCode}
          ctaCopyLabel={trans('external.refer_a_friend.form.success.copy-code')}
          ctaCopiedLabel={trans('referrals.dashboard.copied')}
          dataTest={'ext-referral-formSuccess-code'}
        />
      )
    }
  ];

  return (
    <div className="formSuccess">
      <SectionHeading
        text={trans('external.refer_a_friend.form.success.title')}
        theme="dark"
        type="none"
      />
      <div className="formSuccess__wrapper--mobile">
        <Tabs items={sections} />
      </div>
      <div className="formSuccess__wrapper--desktop">
        {sections.map(section => section.render())}
      </div>
      <div className="formSuccess__sharingMethods">
        <SharingMethods
          title={trans('external.refer_a_friend.form.success.share-your-code')}
          methods={[whatsapp, email, facebook, twitter]}
          onClick={onShareMethodClick}
        />
      </div>
    </div>
  );
};

FormSuccess.propTypes = {
  code: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired
};

export default FormSuccess;
